import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Dropdown, Avatar, Badge } from "antd";
import Gravatar from "react-gravatar";
import get from "lodash/get";
import { DownOutlined, BellTwoTone } from "@ant-design/icons";

import { getMenuItems } from "../../utilities/layout";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/authActions";
import { NOTIFICATION } from "../../constants/routes";
import { getNotificationUnreadCount } from "../../redux/actions/notificationActions";

const { Header } = Layout;

const LayoutHeader = () => {
  const auth = useSelector((state) => get(state, "auth"));
  const user = get(auth, "user");
  
  const [notificationCount, setNotificationCount] = React.useState(0);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const onClickLogout = () => {
    dispatch(logout());
  };

  const onClickLink = (page) => {
    navigate(page)
  }

  const fetchNotificationCount = () => {
    dispatch(getNotificationUnreadCount()).then((result) => {
      setNotificationCount(get(result, "count"));
    });
  };

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(
      () => {
        fetchNotificationCount();
      },
      2 * 600 * 1000,
    );
    clearInterval(interval);
  }, []);

  return (
    <Header
      style={{
        padding: 0,
        height: 73,
      }}
    >
      <div className=" flex h-full">
        <div className="flex flex-row justify-end items-center space-x-5 px-10 h-full w-full flex-1  ">
          <Badge
            count={notificationCount}
            size="large"
            offset={[5, -3]}
            className="mr-4 cursor-pointer"
          >
            <BellTwoTone
              twoToneColor="#ff4d4f"
              className="text-2xl  text-gray-500"
              onClick={() => {
                navigate(NOTIFICATION);
              }}
            />
          </Badge>
          <Dropdown
            menu={{
              items: getMenuItems(onClickLogout,onClickLink),
            }}
            placement="bottom"
          >
            <div className="flex flex-row items-center justify-center  h-full hover:cursor-pointer min-w-28">
              <Avatar
                className="avtaar"
                icon={<Gravatar email={get(user, "email")} size={20} />}
              />
              <span className="text-black font-semibold text-base items-center pr-4 pl-1  ">
                {get(user, "name")}
              </span>

              <DownOutlined className="text-primary" />
            </div>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default LayoutHeader;
